import type { ReactNode } from "react";
import { cn } from "@wa/ui";

/**
 * One number the reader came for, with the words that say what it is.
 *
 * The label is small and the number is large, because on a money screen the
 * number is the content and the label is its caption. Tabular figures, so a
 * column of them lines up and a total does not shift as its digits change.
 */
export function Figure({
  label,
  value,
  hint,
  icon,
  size = "md",
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  /** A short line under the number - a date, a count. */
  hint?: ReactNode;
  /** A small glyph before the label, for a number that carries a status. */
  icon?: ReactNode;
  size?: "md" | "lg";
  className?: string;
}) {
  return (
    <div className={cn("min-w-0", className)}>
      <div className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-foreground/70">
        {icon}
        {label}
      </div>
      <div
        className={cn(
          "mt-1 font-display font-extrabold tabular-nums tracking-tight",
          size === "lg" ? "text-4xl" : "text-2xl md:text-3xl",
        )}
      >
        {value}
      </div>
      {hint && <div className="mt-1.5 text-sm text-foreground/70">{hint}</div>}
    </div>
  );
}
